import { useState } from 'react';
import './studycircle.css';

function StudyCircle() {
    const [activeIndex, setActiveIndex] = useState(0);

    const toggleItem = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const faqItems = [
        {
            icon: 'https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/computer-gold.svg',
            title: 'Study Circle Guidelines',
            text: (
                <a href="https://www.sathyasai.org/organisation/guidelines/study-circle" target="_blank" rel="noopener noreferrer">
                    Get Started Study Circle Guideline
                </a>
            ),
        },
        {
            icon: 'https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/calendar-gold.svg',
            title: '108 Names of Sathya Sai Baba Study Guide',
            text: (
                <>
                    <a href="https://ssscmke.org/documents/108-mirrors-study-guide-1.pdf" target="_blank" rel="noopener noreferrer">Part 1: 108 Names of Sathya Sai Baba</a><br />
                    <a href="https://ssscmke.org/documents/108-mirrors-study-guide-2.pdf" target="_blank" rel="noopener noreferrer">Part 2: 108 Names of Sathya Sai Baba</a><br />
                    <a href="https://ssscmke.org/documents/108-mirrors-study-guide-3.pdf" target="_blank" rel="noopener noreferrer">Part 3: 108 Names of Sathya Sai Baba</a><br />
                    <a href="https://ssscmke.org/documents/108-mirrors-study-guide-4.pdf" target="_blank" rel="noopener noreferrer">Part 4: 108 Names of Sathya Sai Baba</a><br />
                    <a href="https://ssscmke.org/documents/108-mirrors-study-guide-5.pdf" target="_blank" rel="noopener noreferrer">Part 5: 108 Names of Sathya Sai Baba</a><br />
                    <a href="https://ssscmke.org/documents/108-mirrors-study-guide-6.pdf" target="_blank" rel="noopener noreferrer">Part 6: 108 Names of Sathya Sai Baba</a><br />
                </>
            ),
        },
        {
            icon: 'https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/map-pin-gold.svg',
            title: 'Aradhana Study Guide',
            text: < a href="https://ssscmke.org/documents/AradhanaStudyGuideFinal.pdf" target="_blank" rel="noopener noreferrer">Aradhana Study Guide</a>,
        },
        {
            icon: 'https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/map-pin-gold-2.svg',
            title: 'Purity and Unity Study Guide',
            text: <>
                    <a href="https://ssscmke.org/documents/StudyGuide-Purity.pdf" target="_blank" rel="noopener noreferrer">Purity Study Guide</a><br />
                    <a href="https://ssscmke.org/documents/StudyGuide-Unity.pdf" target="_blank" rel="noopener noreferrer">Unity Study Guide</a><br />
                </>
        },
    ];

    return (
        <section id="services-1666">
            <div className="cs-container">
                <div className="cs-image-group">
                    <picture className="cs-picture">
                        <source media="(max-width: 600px)" srcSet="/images/studycircle/studycircle-1.jpeg" />
                        <source media="(min-width: 601px)" srcSet="/images/studycircle/studycircle-1.jpeg" />
                        <img loading="lazy" decoding="async" src="/images/studycircle/studycircle-1.jpeg" alt="people standing" width="605" height="690" />
                    </picture>
                    <img className="cs-floater" src="/images/studycircle/studycircle-1.jpeg" alt="graphic" loading="lazy" decoding="async" height="710" aria-hidden="true" width="690" />
                </div>
                <div className="cs-content">
                    <span className="cs-topper">Study Circle</span>
                    <h2 className="cs-title">Analyze Spiritual points to derive Practical Values for daily life</h2>
                    <p className="cs-text">
                        Study Circle is not merely reading books, but its primary goal is transformation, not just information, aiming for "construction" of character over mere "instruction". It is a collaborative, interactive session that turns theoretical knowledge into spiritual wisdom.
                    </p>
                    <ul className="cs-faq-group">
                        {faqItems.map((item, index) => (
                            <li
                                key={index}
                                className={`cs-faq-item${activeIndex === index ? ' active' : ''}`}
                            >
                                <button className="cs-button" onClick={() => toggleItem(index)}>
                                    <img className="cs-icon" aria-hidden="true" loading="lazy" decoding="async" src={item.icon} alt="icon" width="32" height="32" />
                                    <span className="cs-button-text">{item.title}</span>
                                    <span className="cs-indicator" aria-hidden="true"></span>
                                </button>
                                <p className="cs-item-p">{item.text}</p>
                            </li>
                        ))}
                    </ul>
                    <a href="/sse" className="cs-button-solid">Children's SSE</a>
                </div>
            </div>
        </section>
    );
}

export default StudyCircle;